import { articleListQueryKey } from '@/lib/article-list';
import {
  blogArticleListQueryKey,
  blogTopArticleListQueryKey,
} from '@/lib/blog-list';
import { useQuery } from '@tanstack/react-query';
import {
  getArticleDetail,
  getArticleList,
  getBlogArticleList,
  getBlogTopArticleList,
  // getMainTopArticleList,
  getPrivacyArticleList,
} from '../article.service';
import { ApiResponse, QUERY_KEYS } from '../base-api';
import {
  ArticleEntity,
  ArticleListResponse,
  GetArticleListParams,
} from '../types/article.type';

interface QueryError {
  message?: string;
  code?: number;
  status?: number;
}

export const usePrivacyArticleList = () => {
  return useQuery<ApiResponse<ArticleEntity[]>>({
    queryKey: [QUERY_KEYS.ARTICLE, QUERY_KEYS.PRIVACY_POLICY],
    queryFn: getPrivacyArticleList,
  });
};

export const useArticleList = (params?: GetArticleListParams) => {
  return useQuery<ApiResponse<ArticleListResponse>>({
    queryKey: articleListQueryKey(params),
    queryFn: () => getArticleList(params),
  });
};

export const useArticleDetail = (
  id: number,
  initialData?: ApiResponse<ArticleEntity>,
) => {
  return useQuery<ApiResponse<ArticleEntity>>({
    queryKey: [QUERY_KEYS.ARTICLE, QUERY_KEYS.DETAIL, id],
    queryFn: () => getArticleDetail(id),
    enabled: !!id,
    // 서버에서 미리 받은 상세를 초기값으로 넣어 본문을 SSR HTML에 노출(GEO/AEO).
    initialData,
    retry: (failureCount, error) => {
      const queryError = error as QueryError;
      const isNotFoundError =
        queryError.status === 404 ||
        queryError.code === 404 ||
        queryError.message === '게시글을 찾을 수 없습니다.';

      if (isNotFoundError) {
        return false;
      }

      return failureCount < 3;
    },
  });
};

// export const useMainTopArticleList = () => {
//   return useQuery<ApiResponse<ArticleEntity[]>>({
//     queryKey: [QUERY_KEYS.ARTICLE, QUERY_KEYS.LIST, 'main-top'],
//     queryFn: () => getMainTopArticleList(),
//   });
// };

export const useBlogTopArticleList = () => {
  return useQuery<ApiResponse<ArticleEntity[]>>({
    queryKey: blogTopArticleListQueryKey(),
    queryFn: () => getBlogTopArticleList(),
  });
};

export const useBlogArticleList = (params?: GetArticleListParams) => {
  return useQuery<ApiResponse<ArticleListResponse>>({
    queryKey: blogArticleListQueryKey(params),
    queryFn: () => getBlogArticleList(params),
  });
};
